import React from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
// import LogoImage from '../../../../../public/img/output-onlinepngtools.png'
import '../index.scss'
import { CHART_DATA } from '../constants';
import { FEEDBACK_360_SURVEY } from '../../../../../../config/questionTypeConstants';

export const DonutChart = (props) => {
 
    return (
      <BarChartV4 {...props} />
      );
  };

  export class BarChartV4 extends React.Component {
    componentDidMount = () => {
        this.donotChart()
      };


      componentWillUnmount() {
        if (this.root) {
          this.root.dispose();
        }
        // The chart is created via am4core.create and stored on donutChart;
        // dispose it too so the DOM id is freed for a clean remount.
        if (this.donutChart) {
          this.donutChart.dispose();
        }
      }

      componentDidUpdate(prevProps, prevState) {
        // Rebuild on data change. Dispose the existing chart first (stored on
        // donutChart, not this.chart which is never assigned) — without this the
        // old chart stays attached and amcharts throws "id already in use" /
        // "multiple Roots on the same DOM node" on the next create.
        if (this.donutChart) {
          this.donutChart.dispose();
          this.donutChart = null;
        }
        this.donotChart();
      }

      shouldComponentUpdate = (nextProps) => {
        return nextProps.config !== this.props.config || nextProps.data !== this.props.data;
      };
    
      donotChart = () =>{



        let chart = am4core.create(this.props.chartId || "donutChartDiv", am4charts.PieChart);
        chart.logo.disabled = true;
        this.donutChart = chart; // Store the chart instance for later use
        chart.data = this.props.donutData

        // Configure the chart as a donut chart
        chart.innerRadius = am4core.percent(68); // Adjust the inner radius to create a donut chart
        
        // Add and configure series
        let series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "numberOfSubCategory";
        series.dataFields.category = "category";
        // series.slices.template.stroke = null; 
        // series.slices.template.strokeWidth = 0; 
        // series.slices.template.strokeOpacity = 0;
        series.slices.template.propertyFields.stroke = "none"; 
    
        chart.background.fill = am4core.color("#00000000");
    
        series.slices.template.states.create("hover").properties.scale = 1;
        series.slices.template.states.create("hover").properties.opacity = 1;
        series.slices.template.fill = am4core.color("#ffffff")
    
        series.labels.template.text = "{category}";
        // Donut category label font size (COACHING / COLLABORATION / etc.) —
        // overridable via prop. Used by the PDF renderer to compensate for
        // the chart being visually scaled down on the page.
        series.labels.template.fontSize = this.props.categoryFontSize || 25;
        series.labels.template.fontWeight = '500'
    
  
        series.alignLabels = false;
        series.labels.template.bent = true;
        series.labels.template.radius = 10;
        series.labels.template.padding(0, 0, 0, 0);
        series.labels.template.fill = am4core.color("#00000");
        series.ticks.template.disabled = true;


        let paletteArcteryx = [am4core.color("#034F95"), am4core.color("#BCBDBD"), am4core.color("#5D87AE"), am4core.color("#4F4F4F")]
        let paletteApplied = [am4core.color("#fcb140"), am4core.color("#3F8AC6"), am4core.color("#be6bab"), am4core.color("#00a14b"), am4core.color("#24aae1")]

        // An explicit palette can be passed in (e.g. by the Circumplex config
        // preview). Falls back to the built-in project palettes.
        const selectedPalette = this.props.labelPalette
          ? this.props.labelPalette.map((color) => am4core.color(color))
          : this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX
            ? paletteArcteryx
            : paletteApplied;

        // The config preview omits the category labels (no real names yet).
        if (this.props.hideLabels) {
          series.labels.template.disabled = true;
          series.ticks.template.disabled = true;
        }
        // Add divider line
        series.slices.template.stroke = am4core.color("#00000"); // Set stroke color to black
        series.slices.template.strokeWidth = 1; // Set stroke width
        // series.slices.template.strokeOpacity = 0.7; // Set stroke opacity
    
        // Add data
    
    
        // const numPartitions = 4; 
        // const partitionAngles = this.createPartitionAngles(chart.data);
         
        //  // Loop through the partitionAngles array and set the startAngle and endAngle for each slice
        //  partitionAngles.forEach((partition, index) => {
        //   series.slices.template.adapter.add("startAngle", (startAngle, target) => {
        //      if (target.dataItem && target.dataItem.index === index) {
        //        return partition.start;
        //      }
        //      return startAngle;
        //   });
         
        //   series.slices.template.adapter.add("endAngle", (endAngle, target) => {
        //      if (target.dataItem && target.dataItem.index === index) {
        //        return partition.end;
        //      }
        //      return endAngle;
        //   });
        //  });

        series.labels.template.adapter.add("textOutput", function(text) {
          if (text === "Team Development" || text === "High Performing Teams") {
            return "HIGH PERFORMANCE TEAM"
          }
          return text.toUpperCase();
        });
    
        series.labels.template.adapter.add("fill", function (fill, target) {

          let index = target.dataItem.index;
          return selectedPalette[index];
        });
    
    }

    render() {
        return (
            <div className='graph-container'>
    
                <div className='donut-chart' id={this.props.chartId || "donutChartDiv"} ></div>
    
            </div>
        );
      }
  }